export default __webpack_public_path__ + "static/media/church-community-builder-label.75e081f6.png";